<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <h5 class="content-header-title float-left pr-1 mb-0">
              {{ house.name }}
            </h5>
            <div class="breadcrumb-wrapper col-12">
              <ol class="breadcrumb p-0 mb-0">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'DashboardPage' }">
                    <em class="bx bx-home-alt"></em>
                  </router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'HousesPage' }">Houses</router-link>
                </li>
                <li class="breadcrumb-item active">{{ house.name }}</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-body">
      <div class="row match-height">
        <div class="col-12">
          <div class="text-right">
            <router-link :to="{ name: 'HousesPage' }">
              <button class="btn btn-secondary mb-1">Go back to list</button>
            </router-link>
          </div>
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <Alert
                  v-if="error == 'error-message'"
                  :text="errorText"
                  type="danger"
                  dismissable="false"
                />
                <House :house="house" :owner="owner" :rent="rentData" :contractsData="contracts" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import House from "@/components/Houses/House";
import Alert from "@/components/Alerts";
export default {
  components: {
    House,
    Alert,
  },

  data() {
    return {
      house: {},
      houseUid: this.$route.params.uid,
      owner: {},
      rentData: [],
      error: "",
      errorText: "",
      contracts: [],
    };
  },

  computed: {
    isSuperadmin() {
      return this.$store.state.currentUser.user.type === "superadmin";
    },
  },

  methods: {
    getHouse() {
      let self = this;
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait",
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent",
        },
      });
      this.$apiCall
        .get(`/v1/properties/${this.houseUid}`)
        .then((response) => {
          self.owner = response.data.owner.user
            ? response.data.owner.user
            : response.data.owner.invite;
          self.house = response.data;

          let proposalsURI = [];
          if (this.house.contractProposals) {
            this.house.contractProposals.map((proposal) => {
              proposalsURI.push(
                this.$apiCall.get(`/v1/contracts/proposals/${proposal}`)
              );
            });

            Promise.all(proposalsURI)
              .then((response) => {
                response.forEach((prop) => this.rentData.push(prop.data));
                this.getContracts();
              })
              .catch((error) => {
                $.unblockUI();
                this.error = "error-message";
                this.errorText = `<strong>Ops!</strong> ${error.response.data.message}`;
                $("html, body").animate(
                  {
                    scrollTop: $("body").offset().top,
                  },
                  500
                );
              });
          } else {
            $.unblockUI();
          }
        })
        .catch((error) => {
          $.unblockUI();
          this.error = "error-message";
          this.errorText = `<strong>Ops!</strong> ${error.response.data.message}`;
          $("html, body").animate(
            {
              scrollTop: $("body").offset().top,
            },
            500
          );
        });
    },

    getContracts() {
      let contractsURI = [];
      if (this.house.contracts) {
        this.house.contracts.map((contract) =>
          contractsURI.push(
            this.$apiCall.get(`/v1/contracts/contract/${contract}`)
          )
        );

        Promise.all(contractsURI)
          .then((response) => {
            $.unblockUI();
            response.forEach(contract => this.contracts.push(contract.data));
          })
          .catch((error) => {
            $.unblockUI();
            this.error = "error-message";
            this.errorText = `<strong>Ops!</strong> ${error.response.data.message}`;
            $("html, body").animate(
              {
                scrollTop: $("body").offset().top,
              },
              500
            );
          });
      } else {
        $.unblockUI();
      }
    },
  },

  mounted() {
    this.getHouse();
  },
};
</script>

